import { useEffect, useState } from "react";

const KEY = "tabId";

export const TAB_ID_CHANGED_EVENT = "TAB_ID_CHANGED_EVENT";

export const generateTabId = () => {
  if (typeof window === "undefined") return;
  const epochDateTime = Date.now();
  sessionStorage.setItem(KEY, epochDateTime.toString());
  window.dispatchEvent(new Event(TAB_ID_CHANGED_EVENT));
};

const getTabID = () => sessionStorage.getItem(KEY);
const init = typeof window !== "undefined" ? getTabID() : null;

export const useTabId = () => {
  const [tabId, setTabId] = useState<string | null>(init);

  useEffect(() => {
    const cb = () => {
      setTabId(getTabID());
    };

    window.addEventListener(TAB_ID_CHANGED_EVENT, cb);

    if (!getTabID()) {
      generateTabId();
    }

    return () => {
      window.removeEventListener(TAB_ID_CHANGED_EVENT, cb);
    };
  }, []);

  return tabId;
};
